import * as React from 'react';
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import NotFoundStyle from "./NotFoundStyle";

function NotFound({ ...props }) {
    const { classes } = props;
    return (
        <div className={classes.notFoundContianer}>
            <div className={classes.notFoundContent}>
                <h1>404 - The page you are looking for is not found!</h1>
            </div>
        </div>
    );
};

NotFound.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(NotFoundStyle)(NotFound);